// extracted by mini-css-extract-plugin
export default {"title":"NoSpaceForOverquotaUserModal__title--xfrd3","text":"NoSpaceForOverquotaUserModal__text--1S4vQ"};